"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Separator = exports.CrumbLink = exports.Crumb = exports.ActiveCrumb = exports.CrumbsContainer = exports.Wrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Link = _interopRequireDefault(require("../Link"));

var _Layout = require("../Layout");

var Wrapper = (0, _styled.default)('div')(function (_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      fonts = _ref$theme.fonts,
      breadcrumbs = _ref$theme.breadcrumbs;
  return {
    display: 'flex',
    flexDirection: 'column',
    background: colors[breadcrumbs.backgroundColor],
    color: colors.greydark,
    fontFamily: fonts.heading,
    width: '100%',
    borderTop: "".concat(breadcrumbs.wrapperBorderTop.width, " solid ").concat(colors[breadcrumbs.wrapperBorderTop.color])
  };
});
exports.Wrapper = Wrapper;
var CrumbsContainer = (0, _styled.default)(_Layout.Container)(function (_ref2) {
  var space = _ref2.theme.space;
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: '5rem',
    paddingTop: space.medium,
    paddingBottom: space.medium
  };
});
exports.CrumbsContainer = CrumbsContainer;
var ActiveCrumb = (0, _styled.default)('span')(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      colors = _ref3$theme.colors,
      breadcrumbs = _ref3$theme.breadcrumbs;
  return {
    color: colors[breadcrumbs.activeLinkColor],
    textTransform: breadcrumbs.textTransform,
    fontWeight: breadcrumbs.activeCrumbFontWeight
  };
});
exports.ActiveCrumb = ActiveCrumb;
var Crumb = (0, _styled.default)('span')(function (_ref4) {
  var _ref4$theme = _ref4.theme,
      colors = _ref4$theme.colors,
      breadcrumbs = _ref4$theme.breadcrumbs;
  return {
    textTransform: breadcrumbs.textTransform,
    color: colors[breadcrumbs.arrowLinkColor]
  };
});
exports.Crumb = Crumb;
var CrumbLink = (0, _styled.default)(_Link.default)(function (_ref5) {
  var _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      breadcrumbs = _ref5$theme.breadcrumbs;
  return {
    span: {
      borderBottomColor: colors[breadcrumbs.linkBorderColor],
      color: colors[breadcrumbs.linkColor]
    },
    'a:hover &, &:hover, a:hover span &, &:hover span': {
      borderBottomColor: "".concat(colors[breadcrumbs.linkBorderColorHover], " !important")
    }
  };
});
exports.CrumbLink = CrumbLink;
var Separator = (0, _styled.default)('span')(function (_ref6) {
  var space = _ref6.theme.space;
  return {
    marginLeft: space.xsmall,
    marginRight: space.xsmall
  };
});
exports.Separator = Separator;